module.exports = __webpack_public_path__ + "static/img/shareBtn.8bff5b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/shareBtn.png
// module id = aUP2
// module chunks = 1